import Backbone from "backbone";

window.Backbone = Backbone;
